import { MARKER_TYPES } from 'entities/map';
import { ROADSIDE_SERVICES_CODES } from '../constants';

export const getRoadsideServiceType = (roadsideServiceCode: number) => ({
  [ROADSIDE_SERVICES_CODES.gasStation]: MARKER_TYPES.petrolStation,
  [ROADSIDE_SERVICES_CODES.roadPay]: MARKER_TYPES.roadPaymentPoint,
  [ROADSIDE_SERVICES_CODES.parking]: MARKER_TYPES.parking,
  [ROADSIDE_SERVICES_CODES.carWash]: MARKER_TYPES.carWash,
  [ROADSIDE_SERVICES_CODES.autoService]: MARKER_TYPES.carService,
  [ROADSIDE_SERVICES_CODES.guard]: MARKER_TYPES.convoy,
  [ROADSIDE_SERVICES_CODES.boat]: MARKER_TYPES.ferry,
  [ROADSIDE_SERVICES_CODES.railway]: MARKER_TYPES.railwayPlatform,
  [ROADSIDE_SERVICES_CODES.store]: MARKER_TYPES.autoGoodsStore,
  [ROADSIDE_SERVICES_CODES.cafe]: MARKER_TYPES.cafe,
  [ROADSIDE_SERVICES_CODES.truckWash]: MARKER_TYPES.truckWash,
  [ROADSIDE_SERVICES_CODES.automobileWash]: MARKER_TYPES.carWash,
  [ROADSIDE_SERVICES_CODES.evCharging]: MARKER_TYPES.evCharging
}[roadsideServiceCode]);